import { put, call } from 'redux-saga/effects';
import { UserAction,UIAction } from '../actions';
import { UserService } from '../services';
import { generateReadableError } from 'hooks';



export function* getUsersList(action) {
  yield put(UIAction.showMessages(null));
  yield put(UIAction.showLoading(true));
  try {
    const {data}  = yield call(UserService.getInstance().fetchUsersList, action.payload);
    yield put(UserAction.getUsersSuccess(data));
    yield put(UIAction.showLoading(false));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showLoading(false));
  }
}

export function* getReportUsers(action) {
  yield put(UIAction.showMessages(null));
  yield put(UIAction.showLoading(true));
  try {
    const {data}  = yield call(UserService.getInstance().fetchReportUsers, action.payload);
    yield put(UserAction.getReportUsersSuccess(data));
    yield put(UIAction.showLoading(false));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showLoading(false));
  }
}

export function* getAdminUsers(action) {
  //yield put(UIAction.showMessages(null));
  yield put(UIAction.showLoading(true));
  try {
    const {data}  = yield call(UserService.getInstance().fetchAdminUsersList, action.payload);
    yield put(UserAction.getAdminUsersSuccess(data));
    yield put(UIAction.showLoading(false));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showLoading(false));
  }
}

export function* getUserProfile(action) {
  yield put(UIAction.showMessages(null));
  yield put(UIAction.showProfileLoading(true));
  try {
    const {data}  = yield call(UserService.getInstance().getUserProfile, action.payload);
    yield put(UserAction.getUserProfileSuccess(data));
    yield put(UIAction.showProfileLoading(false));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showProfileLoading(false));
  }
}


export function* suspendAccount(action) {
  yield put(UIAction.showMessages(null));
  yield put(UIAction.showMainLoading(true));
  try {
    const {data}  = yield call(UserService.getInstance().suspendAccount, action.payload);
    yield put(UserAction.suspendAccountSuccess(data));
    yield put(UIAction.showMainLoading(false));
    yield put(UIAction.showMessages({ status: 'success', message: data.responseMessage }));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showMainLoading(false));
  }
}

export function* updateProfile(action) {
  yield put(UIAction.showMessages(null));
  yield put(UserAction.updateProfileSuccess(null));
  yield put(UIAction.showMainLoading(true));
  try {
    const {data}  = yield call(UserService.getInstance().updateProfile, action.payload);
    yield put(UserAction.updateProfileSuccess(data));
    yield put(UIAction.showMainLoading(false));
    yield put(UIAction.showMessages({ status: (data.responseMessage && (data.responseCode === 200 || data.responseCode === 201))?'success':'danger', message: data.responseMessage }));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showMainLoading(false));
  }
}


export function* addUser(action) {
  yield put(UIAction.showMessages(null));
  yield put(UIAction.showMainLoading(true));
  yield put(UserAction.addUserSuccess(null));
  try {
    const {data}  = yield call(UserService.getInstance().addUser, action.payload);
    yield put(UserAction.addUserSuccess(data));
    yield put(UIAction.showMainLoading(false));
    yield put(UIAction.showMessages({ status: (data.responseMessage && (data.responseCode === 200 || data.responseCode === 201))?'success':'danger', message: data.responseMessage }));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showMainLoading(false));
  }
}


export function* getUsersLocations(action) {

  yield put(UIAction.showMessages(null));
  //yield put(UIAction.showLoading(true));
  try {
    const {data}  = yield call(UserService.getInstance().fetchUsersLocations, action.payload);
    yield put(UserAction.getUsersLocationsSuccess(data));
    yield put(UIAction.showLoading(false));
  }
  catch (e) {
    console.log(e)
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showLoading(false));
  }
}

export function* getFollowers(action) {

  yield put(UIAction.showMessages(null));
  yield put(UIAction.showLoading(true));
  yield put(UserAction.getFollowersSuccess(null));
  try {
    const {data}  = yield call(UserService.getInstance().fetchFollowers, action.payload);
    yield put(UserAction.getFollowersSuccess(data));
    yield put(UIAction.showLoading(false));
  }
  catch (e) {
    console.log(e)
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showLoading(false));
  }
}

export function* getFollowing(action) {

  yield put(UIAction.showMessages(null));
  yield put(UIAction.showLoading(true));
  yield put(UserAction.getFollowingSuccess(null));
  try {
    console.log('Following')
    const {data}  = yield call(UserService.getInstance().fetchFollowing, action.payload);
    yield put(UserAction.getFollowingSuccess(data));
    yield put(UIAction.showLoading(false));
  }
  catch (e) {
    console.log(e)
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showLoading(false));
  }
}



export function* changeAppPassword(action) {
  yield put(UIAction.showMessages(null));
  yield put(UIAction.showMainLoading(true));
  yield put(UserAction.changeAppPasswordSuccess(null));
  try {
    const {data}  = yield call(UserService.getInstance().changeAppPassword, action.payload);
    yield put(UserAction.changeAppPasswordSuccess(data));
    yield put(UIAction.showMainLoading(false));
    yield put(UIAction.showMessages({ status: (data.responseMessage && (data.responseCode === 200 || data.responseCode === 201))?'success':'danger', message: data.responseMessage }));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showMainLoading(false));
  }
}

export function* updateAutoFollow(action) {
  yield put(UIAction.showMessages(null));
  yield put(UIAction.showMainLoading(true));
  try {
    const {data}  = yield call(UserService.getInstance().updateAutoFollow, action.payload);
    yield put(UserAction.updateAutoFollowSuccess(data));
    yield put(UIAction.showMainLoading(false));
    yield put(UIAction.showMessages({ status: (data.responseMessage && (data.responseCode === 200 || data.responseCode === 201))?'success':'danger', message: data.responseMessage }));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showMainLoading(false));
  }
}

// RSS Feed sagas
export function* generateRssFeed(action) {
  yield put(UIAction.showMessages(null));
  yield put(UIAction.showMainLoading(true));
  try {
    const {data}  = yield call(UserService.getInstance().generateRssFeed, action.payload);
    yield put(UserAction.generateRssFeedSuccess(data));
    yield put(UIAction.showMainLoading(false));
    yield put(UIAction.showMessages({ status: (data.responseMessage && (data.responseCode === 200 || data.responseCode === 201))?'success':'danger', message: data.responseMessage }));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showMainLoading(false));
  }
}

export function* getRssFeedInfo(action) {
  yield put(UIAction.showMessages(null));
  try {
    const {data}  = yield call(UserService.getInstance().getRssFeedInfo, action.payload);
    yield put(UserAction.getRssFeedInfoSuccess(data));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
  }
}

export function* toggleRssFeed(action) {
  yield put(UIAction.showMessages(null));
  yield put(UIAction.showMainLoading(true));
  try {
    const {data}  = yield call(UserService.getInstance().toggleRssFeed, action.payload);
    yield put(UserAction.toggleRssFeedSuccess(data));
    yield put(UIAction.showMainLoading(false));
    yield put(UIAction.showMessages({ status: (data.responseMessage && (data.responseCode === 200 || data.responseCode === 201))?'success':'danger', message: data.responseMessage }));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showMainLoading(false));
  }
}



